// ** React Imports
import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'

// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './redux/store-config/store'

// ** Toast & ThemeColors Context
import { ToastContainer } from 'react-toastify'
import { ThemeContext } from './utility/context/ThemeColors'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'


// ** Sweetalert 2
import 'sweetalert2/src/sweetalert2.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'
import 'semantic-ui-css/semantic.min.css'
// ** Service Worker
import * as serviceWorker from './serviceWorker'
import SpinnerComponent from "./@core/components/spinner/Fallback-spinner";
import './index.scss'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// ** react-intl-tel-input
import 'react-intl-tel-input/dist/main.css'
import { hydrate, render } from "react-dom";

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

// react -snap for meta tags adding issue
// const APP = (
//     <Provider store={store}>
//         <Suspense fallback={<SpinnerComponent isRender={true}/>}>
//             <SpinnerComponent/>
//             <ThemeContext>
//                 <LazyApp />
//                 <ToastContainer newestOnTop />
//             </ThemeContext>
//         </Suspense>
//     </Provider>
// );
//
// const rootElement = document.getElementById("root");
// if (rootElement.hasChildNodes()) {
//     hydrate(APP, rootElement);
// } else {
//     render(APP, rootElement);
// }


ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<SpinnerComponent isRender={true}/>}>
        <SpinnerComponent/>
      <ThemeContext>
              <LazyApp />
        <ToastContainer newestOnTop />
      </ThemeContext>
    </Suspense>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
